import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetCollegePredictorRequestType,
  GetCollegePredictorResponseType
} from '../../../services/NwCollegePredictorServices/APIService/types';

import { useNwCollegePredictorService } from '../useNwCollegePredictorService';

interface UseGetPredictedCollegeDataResponseInterface {
  getPredictedCollegeDataAPI: UseMutateAsyncFunction<
    GetCollegePredictorResponseType,
    unknown,
    {
      limit: number;
      offset: number;
      requestObject: GetCollegePredictorRequestType;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetPredictedCollegeData =
  (): UseGetPredictedCollegeDataResponseInterface => {
    const { nwCollegePredictorServiceService } = useNwCollegePredictorService();

    const getPredictedCollegeData = ({
      limit,
      offset,
      requestObject
    }: {
      limit: number;
      offset: number;
      requestObject: GetCollegePredictorRequestType;
    }) => {
      return nwCollegePredictorServiceService.getPredictedCollegeData({
        limit,
        offset,
        requestObject
      });
    };

    const { mutateAsync, error, status } = useMutation(
      getPredictedCollegeData,
      {
        mutationKey: ['getPredictedCollegeData'],
        retry: 3,
        retryDelay: (attempt) =>
          Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 20 * 1000)
      }
    );

    return {
      getPredictedCollegeDataAPI: mutateAsync,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useGetPredictedCollegeData };
